import { FC } from 'react';

import { ICheckboxItem } from '~/src/components/CheckboxFilters';
import { TMenuItem } from '~/src/components/FilterMenu';
import FilterMenu from '~/src/components/FilterMenu';

import * as ST from './styled';

interface IProps {
    activeItem: number,
    hasCityTariffs: boolean,
    hasVillageTariffs: boolean,
    tariffFiltersData: ICheckboxItem[],
    tariffSwitcherData: TMenuItem[],
    onToggleFilter: (id: string) => void,
    className?: string,
}

export const FiltersForTariffs: FC<IProps> = ({
    hasCityTariffs,
    hasVillageTariffs,
    tariffFiltersData,
    tariffSwitcherData,
    onToggleFilter,
    activeItem,
    className,
}) => {
    const hasBothTariffs = hasCityTariffs && hasVillageTariffs;
    return (
        <ST.FiltersForTariffs className={className}>
            <ST.TariffSwitcherWrap
                isDisplay={hasBothTariffs}
                data-test={'tariff-switcher'}
            >
                <FilterMenu
                    items={tariffSwitcherData}
                    activeItem={activeItem}
                    disabled={!hasBothTariffs}
                />
            </ST.TariffSwitcherWrap>
            <ST.SCheckboxFilters
                items={tariffFiltersData}
                onChange={onToggleFilter}
            />
        </ST.FiltersForTariffs>
    );
};
